import { createElement, HTMLAttributes, memo } from "react";
import classNames from "classnames";

import { ReactComponent as BackgroundCircle } from "./icons/background-circle.svg";
import { ReactComponent as BackgroundGrid } from "./icons/background-grid.svg";

import styles from "./styles.module.scss";

export type  EmptyStateIconBackgroundType = "circle" | "grid";

export type EmptyStateIconBackgroundProps = HTMLAttributes<HTMLDivElement> & {
  type: EmptyStateIconBackgroundType
}

export const EmptyStateIconBackground = memo<EmptyStateIconBackgroundProps>((
  {
    type,
    children,
    className,
    ...props
  }) => {
  return (
    <div
      {...props}
      className={classNames(className, styles.root)}
    >
      {children}
      {
        createElement(
          type === "circle" ? BackgroundCircle : BackgroundGrid,
          {
            className: styles.background,
          },
        )
      }
    </div>
  );
});
